import React from 'react';
import { observer } from 'mobx-react';
import * as IoC from 'typescript-ioc';
import { IEventBlueprintDTO } from '../../../../api/blueprints/blueprints.dao';
import Text from '../../../global/text/text';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../api/roles.dao';
import DefaultButton from '../../../global/default-button/default-button';
import { IntlShape } from 'react-intl';
import classNames from 'classnames';
import { editText } from '../../../../constants/common-labels.constants';

export type IEventBlueprintListItemProps = {
    item: IEventBlueprintDTO;
    isSelected: boolean;
    openEditModal: () => {};
    intl: IntlShape;
    openTemplateDetails: (blueprintId: string) => void;
};

export const EventBlueprintListItem = observer((props: IEventBlueprintListItemProps): JSX.Element => {
    const { item, openEditModal, isSelected, intl, openTemplateDetails } = props;

    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const createdAt = dateTimeFormatter.dateToFormattedString(new Date(item.createdAt), DateFnsFormats.StringifiedMonthDayYear);
    const hasEditPermission = hasPermission(Permission.EDIT_EVENT_BLUEPRINTS);
    const onOpenEditModal = (): void => {
        if (!hasEditPermission) return;
        openEditModal();
    };
    const cellEffectClasses = classNames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    return (
        <tr onDoubleClick={onOpenEditModal}>
            <Text tag='td' className={cellEffectClasses} message={item.name} withEllipsis />
            <Text tag='td' className={`${cellEffectClasses} created-at--column`} message={createdAt} />
            <Text tag='td' className={cellEffectClasses} message={item.description} withEllipsis />
            <td className={`${cellEffectClasses} blueprint-actions`}>
                <DefaultButton
                    text={intl.formatMessage({
                        id: 'oe.common.viewDetails',
                        defaultMessage: 'View Details',
                        description: 'Label text'
                    })}
                    modifier='cancel'
                    className='visible-while-hovered view-details'
                    onClick={() => openTemplateDetails(item.blueprintId)}
                />
                {hasEditPermission && <DefaultButton
                    text={editText()}
                    modifier='slim'
                    onClick={onOpenEditModal}
                    className='visible-while-hovered edit-template'
                />}
            </td>
        </tr>
    );
});
